/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsListAudiences } from "../funcs/pluginsListAudiences.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAudiencesResult } from "../models/components/listaudiencesresult.js";
import {
  ListAudiencesRequest,
  ListAudiencesSecurity,
} from "../models/operations/listaudiences.js";
import { unwrapAsync } from "../types/fp.js";
export type AudiencesQueryData = ListAudiencesResult;

export function prefetchAudiences(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAudiencesRequest | undefined,
  security?: ListAudiencesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAudiencesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAudiencesQuery(
  client$: GramCore,
  request?: ListAudiencesRequest | undefined,
  security?: ListAudiencesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AudiencesQueryData>;
} {
  return {
    queryKey: queryKeyAudiences({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function audiencesQueryFn(ctx): Promise<AudiencesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsListAudiences(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAudiences(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "listAudiences", parameters];
}
